import React, { Fragment } from 'react';
import LinkTo from './LinkTo';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import localizedRoute from '../utils/localizedRoute';
import { ICategory } from '../models';
import parse from 'html-react-parser';

export default function Breadcrumbs({
  breadcrumbs = [],
  ui = ''
}: {
  breadcrumbs: ICategory[];
  ui?: string;
}) {
  return (
    <>
      {breadcrumbs.map((category, i) => {
        const { name = '', category_name = '', slug = '' } = category;
        const last = i === breadcrumbs.length - 1;
        return (
          <Fragment key={i}>
            {slug ? (
              <LinkTo
                key={i}
                href={localizedRoute(
                  `/shop${slug.startsWith('/') ? '' : '/'}${slug}`
                )}
                className={`${last ? '' : 'opacity-60'} font-normal text-sm ${
                  ui ? 'text-white' : ''
                }`}
              >
                {name ? parse(name) : parse(category_name)}
              </LinkTo>
            ) : (
              <p
                key={i}
                className={`${last ? '' : 'opacity-60'} font-normal text-sm ${
                  ui ? 'text-white' : ''
                }`}
              >
                {name ? parse(name) : parse(category_name)}
              </p>
            )}
            {!last && (
              <ChevronRightIcon
                className={`mx-1 w-4 h-4 opacity-60 ${ui ? 'text-white' : ''} `}
              />
            )}
          </Fragment>
        );
      })}
    </>
  );
}
